import { Container, Row, Col } from 'react-bootstrap'
import NotificationsFeed from './NotificationsFeed'
import OrdersFeed from './OrdersFeed'
import ReviewsFeed from './ReviewsFeed'

const Feeds = () => {
  return (
    <Container>
      <Row className='member-statistical'>
        <Col sm={4}>
          <OrdersFeed />
        </Col>
        <Col sm={4}>{/* <ReviewsFeed /> */}</Col>

        <Col sm={4}>{/* <NotificationsFeed /> */}</Col>
      </Row>
    </Container>
  )
}

export default Feeds
